export default __webpack_public_path__ + "b7e635beae67afdfd9b30b574321707a.png";